// SCSS バンドル
import '../scss/main.scss';

/* =================================================================
 * 共通ユーティリティ
 * ================================================================= */
const onReady = (fn) =>
  (document.readyState === 'loading')
    ? document.addEventListener('DOMContentLoaded', fn, { once: true })
    : fn();
const hasIO = 'IntersectionObserver' in window;

/* =================================================================
 * 1) KV：スクロールで動画にぼかし＋暗くする
 * ================================================================= */
(function kvBlurOnScroll($){
  let ticking = false;

  function update() {
    const scrollY = window.scrollY || document.documentElement.scrollTop || 0;
    const maxScroll = 600;
    const blurValue = Math.min((scrollY / maxScroll) * 30, 30);
    const brightnessValue = 1 - (scrollY / maxScroll) * 0.5; // 最大50%暗く

    const $video = $('.kv_wrap video');

    if ($video.length) {
      $video.css('filter', `blur(${blurValue}px) brightness(${brightnessValue})`);
    }

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }

  onReady(() => {
    update();
    $(window).on('scroll', onScroll);
  });
})(jQuery);
/* =================================================================
 * 3) Pickup Slider：4つ表示 + 次がチラ見え + カスタム矢印
 * ================================================================= */
(function pickupSlider($){
  onReady(() => {
    const $slider = $('.pickup_slider');
    $slider.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      dots: false,
      autoplay: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });

    function setFirstVisible() {
      $slider.find('.slick-slide').removeClass('is-first');
      // slick-clonedではない、かつslick-activeの最初のスライド
      $slider.find('.slick-slide.slick-active:not(.slick-cloned)').first().addClass('is-first');
    }
    setFirstVisible();
    $slider.on('afterChange', function() {
      setFirstVisible();
    });

    $('.prev-arrow').on('click', function() {
      $slider.slick('slickPrev');
    });

    $('.next-arrow').on('click', function() {
      $slider.slick('slickNext');
    });
  });
})(jQuery);

/* =================================================================
 * 4) Job Slider：PCは4つ全表示、SPはスライダー
 * ================================================================= */
(function jobSlider($){
  let slickInitialized = false;

  function initSlider() {
    const isMobile = window.matchMedia('(max-width: 768px)').matches;

    if (isMobile && !slickInitialized) {
      $('.job_slide').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2.2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2.2
            }
          }
        ]
      });
      slickInitialized = true;
      // 初期化後に少し遅延させて最初のスライドへ
      setTimeout(function() {
        $('.job_slide').slick('slickGoTo', 0, false);
      }, 50);
    } else if (!isMobile && slickInitialized) {
      $('.job_slide').slick('unslick');
      slickInitialized = false;
    }
  }

  onReady(() => {
    initSlider();
    $(window).on('resize', function() {
      initSlider();
    });

    $('.job-prev-arrow').on('click', function() {
      $('.job_slide').slick('slickPrev');
    });

    $('.job-next-arrow').on('click', function() {
      $('.job_slide').slick('slickNext');
    });
  });
})(jQuery);

/* =================================================================
 * 5) Number Counter：画面に入ったらカウントアップ（小数点対応）
 * ================================================================= */
(function numberCounter($){

  function animateCount($el) {
    const target = parseFloat($el.data('count'));
    const duration = 2000;
    const startTime = performance.now();
    const decimalPlaces = (String(target).split('.')[1] || '').length;

    function update(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easeOut = 1 - Math.pow(1 - progress, 3);
      const current = easeOut * target;

      const formatted = current.toLocaleString(undefined, {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces
      });

      $el.text(formatted);

      if (progress < 1) {
        requestAnimationFrame(update);
      }
    }

    requestAnimationFrame(update);
  }

  onReady(() => {
    if (!hasIO) {
      $('[data-count]').each(function() {
        animateCount($(this));
      });
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const $el = $(entry.target);
          animateCount($el);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.5
    });

    $('[data-count]').each(function() {
      observer.observe(this);
    });
  });

})(jQuery);

/* =================================================================
 * 6) Stat Item Finish：スクロールで左に移動
 * ================================================================= */
(function statItemRunner($){
  let ticking = false;

  function update() {
    const scrollTop = $(window).scrollTop();
    const $target = $('.stat-item--finish');

    if ($target.length) {
      const targetTop = $target.offset().top;
      const targetHeight = $target.outerHeight();
      const windowHeight = $(window).height();

      if (scrollTop + windowHeight > targetTop && scrollTop < targetTop + targetHeight) {
        const progress = (scrollTop + windowHeight - targetTop) / (windowHeight + targetHeight);
        const moveX = progress * -300;

        $target.css('--runner-x', moveX + 'px');
      }
    }

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }

  onReady(() => {
    update();
    $(window).on('scroll', onScroll);
  });
})(jQuery);

// /* =================================================================
//  * 7) Store Map Modal：クリックでモーダル表示
//  * ================================================================= */
// (function storeMapModal($){
//     // エリアごとの画像とキャプション
//     const areaData = {
//         first: {
//             img: 'images/first-button.jpg',
//             caption: '相談カウンター'
//         },
//         second: {
//             img: 'images/second-button.jpg',
//             caption: 'Drエリア　処置スペース'
//         },
//         third: {
//             img: 'images/third-button.jpg',
//             caption: 'DHエリア　スキャンスペース'
//         },
//         waiting: {
//             img: 'images/store_waiting.jpg',
//             caption: '待合室'
//         }
//     };

//     onReady(() => {
//         // ポイントクリック
//         $('.store_map__point').on('click', function() {
//             const area = $(this).data('area');
//             const data = areaData[area];

//             if (data) {
//                 $('.store_modal__img').attr('src', data.img);
//                 $('.store_modal__caption').text(data.caption);
//                 $('.store_modal').addClass('active');
//                 $('body').css('overflow', 'hidden');
//             }
//         });

//         // モーダル閉じる
//         $('.store_modal__close, .store_modal__overlay').on('click', function() {
//             $('.store_modal').removeClass('active');
//             $('body').css('overflow', '');
//         });

//         // ESCキーで閉じる
//         $(document).on('keydown', function(e) {
//             if (e.key === 'Escape') {
//                 $('.store_modal').removeClass('active');
//                 $('body').css('overflow', '');
//             }
//         });
//     });
// })(jQuery);

/* =================================================================
 * 8) Interview Modal：クリックでモーダル表示
 * ================================================================= */
(function interviewModal($){
    onReady(() => {
        const $modal = $('#interviewModal');

        // モーダルを開く
        $('.interview_item').on('click', function() {
            const $item = $(this);

            // データを取得してモーダルに反映
            $modal.find('.modal_img').attr('src', $item.data('img'));
            $modal.find('.modal_name').text($item.data('name'));
            $modal.find('.modal_title').html($item.data('title'));
            $modal.find('.modal_info').html($item.data('info'));
            $modal.find('.modal_before').attr('src', $item.data('before'));
            $modal.find('.modal_after').attr('src', $item.data('after'));

            // タグを生成
            const tags = $item.data('tags').split(',');
            const tagsHtml = tags.map(tag => `<span>${tag}</span>`).join('');
            $modal.find('.modal_tags').html(tagsHtml);

            $modal.addClass('is-open');
            $('body').css('overflow', 'hidden');
        });

        // モーダルを閉じる
        $('.modal_close, .modal_overlay').on('click', function() {
            $modal.removeClass('is-open');
            $('body').css('overflow', '');
        });

        // ESCキーで閉じる
        $(document).on('keydown', function(e) {
            if (e.key === 'Escape') {
                $modal.removeClass('is-open');
                $('body').css('overflow', '');
            }
        });
    });
})(jQuery);

/* =================================================================
 * 9) Case Modal：カテゴリクリックでモーダル表示
 * ================================================================= */
(function caseModal($){
    onReady(() => {
        const $modal = $('#caseModal');
        // 症例データ
        const caseData = {
            deppa: {
                title: '出っ歯（上顎前突）',
                cases: [
                    {
                        before: 'images/case/case_deppa01_before.jpg',
                        after: 'images/case/case_deppa01_after.jpg',
                        info: '治療期間：4ヶ月 / 費用：33万円(税込)'
                    },
                    {
                        before: 'images/case/case_deppa02_before.jpg',
                        after: 'images/case/case_deppa02_after.jpg',
                        info: '治療期間：5ヶ月 / 費用：33万円(税込)'
                    }
                ]
            },
            sukippa: {
                title: 'すきっ歯（空隙歯列）',
                cases: [
                    {
                        before: 'images/case/case_sukippa01_before.jpg',
                        after: 'images/case/case_sukippa01_after.jpg',
                        info: '治療期間：3ヶ月 / 費用：33万円(税込)'
                    },
                    {
                        before: 'images/case/case_sukippa02_before.jpg',
                        after: 'images/case/case_sukippa02_after.jpg',
                        info: '治療期間：4ヶ月 / 費用：33万円(税込)'
                    }
                ]
            },
            gatagata: {
                title: 'ガタガタ（叢生）',
                cases: [
                    {
                        before: 'images/case/case_gatagata01_before.jpg',
                        after: 'images/case/case_gatagata01_after.jpg',
                        info: '治療期間：6ヶ月 / 費用：66万円(税込)'
                    },
                    {
                        before: 'images/case/case_gatagata02_before.jpg',
                        after: 'images/case/case_gatagata02_after.jpg',
                        info: '治療期間：5ヶ月 / 費用：33万円(税込)'
                    }
                ]
            },
            judo: {
                title: '重度の症例',
                cases: [
                    {
                        before: 'images/case/case_judo01_before.png',
                        after: 'images/case/case_judo01_after.png',
                        info: '治療期間：10ヶ月 / 費用：88万円(税込)'
                    },
                    {
                        before: 'images/case/case_judo02_before.png',
                        after: 'images/case/case_judo02_after.png',
                        info: '治療期間：9ヶ月 / 費用：88万円(税込)'
                    }
                ]
            }
        };
        // カテゴリボタンクリック
        $('.case_category_btn').on('click', function() {
            const category = $(this).data('category');
            const data = caseData[category];
            if (!data) return;
            // タイトル設定
            $modal.find('.case_modal__title').text(data.title);
            // 症例リスト生成
            let html = '';
            data.cases.forEach(function(item) {
                html += `
                    <div class="case_modal_item">
                        <div class="case_images">
                            <div class="case_before">
                                <span>Before</span>
                                <img src="${item.before}" alt="治療前">
                            </div>
                            <div class="case_after">
                                <span>After</span>
                                <img src="${item.after}" alt="治療後">
                            </div>
                        </div>
                        <p class="case_info">${item.info}</p>
                    </div>
                `;
            });
            $modal.find('.case_modal__list').html(html);
            // モーダル表示
            $modal.addClass('is-open');
            $('body').css('overflow', 'hidden');
        });
        // モーダルを閉じる
        $('.case_modal__close, .case_modal__overlay').on('click', function() {
            $modal.removeClass('is-open');
            $('body').css('overflow', '');
        });
        // ESCキーで閉じる
        $(document).on('keydown', function(e) {
            if (e.key === 'Escape' && $modal.hasClass('is-open')) {
                $modal.removeClass('is-open');
                $('body').css('overflow', '');
            }
        });
    });
})(jQuery);

/* =================================================================
 * 10) Header Background：top_messageを超えたら背景色をつける
 * ================================================================= */
(function headerBgOnScroll($){
    let ticking = false;

    function update() {
        const $header = $('.top_header');
        const $topMessage = $('.top_message');

        if (!$topMessage.length) return;

        const messageBottom = $topMessage.offset().top + $topMessage.outerHeight();
        const scrollTop = $(window).scrollTop();

        if (scrollTop > messageBottom) {
            $header.addClass('is-scrolled');
        } else {
            $header.removeClass('is-scrolled');
        }

        ticking = false;
    }

    function onScroll() {
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(update);
        }
    }

    onReady(() => {
        update();
        $(window).on('scroll', onScroll);
    });
})(jQuery);

/* =================================================================
 * 11) Gallery Slider & Modal：無限自動スライダーとモーダル表示
 * ================================================================= */
(function gallerySlider($){
    onReady(() => {
        const $slider = $('.gallery_slider');
        const $modal = $('#galleryModal');
        // 無限自動スライダー初期化
        $slider.slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            dots: false,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 5000,
            cssEase: 'linear',
            pauseOnHover: true,
            pauseOnFocus: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 3
                    }
                }
            ]
        });
        // モーダルを開く（イベントデリゲーション）
        $(document).on('click', '.gallery_item', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const $this = $(this);
            // data属性がない場合は画像のsrcを使用
            const imgSrc = $this.data('img') || $this.find('img').attr('src');
            const caption = $this.data('caption') || '';
            $modal.find('.gallery_modal__img').attr('src', imgSrc);
            $modal.find('.gallery_modal__caption').text(caption);
            $modal.addClass('is-open');
            $('body').css('overflow', 'hidden');
            // モーダル表示中はスライダー停止
            $slider.slick('slickPause');
            return false;
        });
        // モーダルを閉じる
        $('.gallery_modal__close, .gallery_modal__overlay').on('click', function(e) {
            e.preventDefault();
            $modal.removeClass('is-open');
            $('body').css('overflow', '');
            // スライダー再開
            $slider.slick('slickPlay');
        });
        // ESCキーで閉じる
        $(document).on('keydown', function(e) {
            if (e.key === 'Escape' && $modal.hasClass('is-open')) {
                $modal.removeClass('is-open');
                $('body').css('overflow', '');
                $slider.slick('slickPlay');
            }
        });
    });
})(jQuery);